interface ColoredBadgeProps {
  color: string;
  children: React.ReactNode;
  /** Render a filled circle of the same color before the label */
  dot?: boolean;
  /** Apply font-semibold */
  bold?: boolean;
}

export const ColoredBadge = ({ color, children, dot = false, bold = false }: ColoredBadgeProps) => (
  <span
    className={`flex items-center gap-1.5 text-xs px-2 py-0.5 rounded-full w-fit${bold ? ' font-semibold' : ''}`}
    style={{ color, backgroundColor: `${color}22`, border: `1px solid ${color}55` }}
  >
    {dot && <span className="inline-block w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: color }} />}
    {children}
  </span>
);
